var en = {
    // Set Filter
    selectAll: '(Select All)',
    selectAllSearchResults: '(Select All Search Results)',
    addCurrentSelectionToFilter: 'Add current selection to filter',
    searchOoo: 'Search...',
    blanks: '(Blanks)',
    noMatches: 'No matches',

    // Number Filter & Text Filter
    filterOoo: 'Filter...',
    equals: 'Equals',
    notEqual: 'Not equal',
    blank: 'Blank',
    notBlank: 'Not blank',
    empty: 'Choose One',

    // Number Filter
    lessThan: 'Less than',
    greaterThan: 'Greater than',
    lessThanOrEqual: 'Less than or equal',
    greaterThanOrEqual: 'Greater than or equal',
    inRange: 'In range',
    inRangeStart: 'from',
    inRangeEnd: 'to',

    // Text Filter
    contains: 'Contains',
    notContains: 'Not contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',
    before: 'Before',
    after: 'After',

    // Filter Conditions
    andCondition: 'AND',
    orCondition: 'OR',

    // Filter Buttons
    applyFilter: 'Apply',
    resetFilter: 'Reset',
    clearFilter: 'Clear',
    cancelFilter: 'Cancel',

    // Filter Titles
    textFilter: 'Text Filter',
    numberFilter: 'Number Filter',
    dateFilter: 'Date Filter',
    setFilter: 'Set Filter',

    // Group Column Filter
    groupFilterSelect: 'Select field:',

    // Advanced Filter
    advancedFilterContains: 'contains',
    advancedFilterNotContains: 'does not contain',
    advancedFilterTextEquals: 'equals',
    advancedFilterTextNotEqual: 'does not equal',
    advancedFilterStartsWith: 'starts with',
    advancedFilterEndsWith: 'ends with',
    advancedFilterBlank: 'is blank',
    advancedFilterNotBlank: 'is not blank',
    advancedFilterEquals: '=',
    advancedFilterNotEqual: '!=',
    advancedFilterGreaterThan: '>',
    advancedFilterGreaterThanOrEqual: '>=',
    advancedFilterLessThan: '<',
    advancedFilterLessThanOrEqual: '<=',
    advancedFilterTrue: 'is true',
    advancedFilterFalse: 'is false',
    advancedFilterAnd: 'AND',
    advancedFilterOr: 'OR',
    advancedFilterApply: 'Apply',
    advancedFilterBuilder: 'Builder',
    advancedFilterValidationMissingColumn: 'Column is missing',
    advancedFilterValidationMissingOption: 'Option is missing',
    advancedFilterValidationMissingValue: 'Value is missing',
    advancedFilterValidationInvalidColumn: 'Column not found',
    advancedFilterValidationInvalidOption: 'Option not found',
    advancedFilterValidationMissingQuote: 'Value is missing an end quote',
    advancedFilterValidationNotANumber: 'Value is not a number',
    advancedFilterValidationInvalidDate: 'Value is not a valid date',
    advancedFilterValidationMissingCondition: 'Condition is missing',
    advancedFilterValidationJoinOperatorMismatch: 'Join operators within a condition must be the same',
    advancedFilterValidationInvalidJoinOperator: 'Join operator not found',
    advancedFilterValidationMissingEndBracket: 'Missing end bracket',
    advancedFilterValidationExtraEndBracket: 'Too many end brackets',
    advancedFilterValidationMessage: 'Expression has an error. ${variable1} - ${variable2}.',
    advancedFilterValidationMessageAtEnd: 'Expression has an error. ${variable} at end of expression.',
    advancedFilterBuilderTitle: 'Advanced Filter',
    advancedFilterBuilderApply: 'Apply',
    advancedFilterBuilderCancel: 'Cancel',
    advancedFilterBuilderAddButtonTooltip: 'Add Filter or Group',
    advancedFilterBuilderRemoveButtonTooltip: 'Remove',
    advancedFilterBuilderMoveUpButtonTooltip: 'Move Up',
    advancedFilterBuilderMoveDownButtonTooltip: 'Move Down',
    advancedFilterBuilderAddJoin: 'Add Group',
    advancedFilterBuilderAddCondition: 'Add Filter',
    advancedFilterBuilderSelectColumn: 'Select a column',
    advancedFilterBuilderSelectOption: 'Select an option',
    advancedFilterBuilderEnterValue: 'Enter a value...',
    advancedFilterBuilderValidationAlreadyApplied: 'Current filter already applied.',
    advancedFilterBuilderValidationIncomplete: 'Not all conditions are complete.',
    advancedFilterBuilderValidationSelectColumn: 'Must select a column.',
    advancedFilterBuilderValidationSelectOption: 'Must select an option.',
    advancedFilterBuilderValidationEnterValue: 'Must enter a value.',

    // Side Bar
    columns: 'Columns',
    filters: 'Filters',
    actions: 'Row actions',

    // columns tool panel
    pivotMode: 'Pivot Mode',
    groups: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
    values: 'Values',
    valueColumnsEmptyMessage: 'Drag here to aggregate',
    pivots: 'Column Labels',
    pivotColumnsEmptyMessage: 'Drag here to set column labels',

    // Header of the Default Group Column
    group: 'Group',

    // Row Drag
    rowDragRow: 'row',
    rowDragRows:'rows',

    // Other
    loadingOoo: 'Loading...',
    loadingError: 'ERR',
    noRowsToShow: 'No Rows To Show',
    enabled: 'Enabled',

    // Menu
    pinColumn: 'Pin Column',
    pinLeft: 'Pin Left',
    pinRight: 'Pin Right',
    noPin: 'No Pin',
    valueAggregation: 'Value Aggregation',
    noAggregation: 'None',
    autosizeThiscolumn: 'Autosize This Column',
    autosizeAllColumns: 'Autosize All Columns',
    groupBy: 'Group by',
    ungroupBy: 'Un-Group by',
    ungroupAll: 'Un-Group All',
    addToValues: 'Add ${variable} to values',
    removeFromValues: 'Remove ${variable} from values',
    addToLabels: 'Add ${variable} to labels',
    removeFromLabels: 'Remove ${variable} from labels',
    resetColumns: 'Reset Columns',
    expandAll: 'Expand All Row Groups',
    collapseAll: 'Close All Row Groups',
    copy: 'Copy',
    ctrlC: 'Ctrl+C',
    ctrlX: 'Ctrl+X',
    copyWithHeaders: 'Copy With Headers',
    copyWithGroupHeaders: 'Copy with Group Headers',
    cut: 'Cut',
    paste: 'Paste',
    ctrlV: 'Ctrl+V',
    export: 'Export',
    csvExport: 'CSV Export',
    excelExport: 'Excel Export',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Sum',
    first: 'First',
    last: 'Last',
    min: 'Min',
    max: 'Max',
    none: 'None',
    count: 'Count',
    avg: 'Average',
    filteredRows: 'Filtered',
    selectedRows: 'Selected',
    totalRows: 'Total Rows',
    totalAndFilteredRows: 'Rows',
    more: 'More',
    to: 'to',
    of: 'of',
    page: 'Page',
    pageLastRowUnknown: '?',
    nextPage: 'Next Page',
    lastPage: 'Last Page',
    firstPage: 'First Page',
    previousPage: 'Previous Page',

    // Pivoting
    pivotColumnGroupTotals: 'Total',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',

    line: 'Line',

    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',
    histogramFrequency: "Frequency",

    combinationChart: 'Combination',
    columnLineCombo: 'Column & Line',
    AreaColumnCombo: 'Area & Column',

    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    autoRotate: 'Auto Rotate',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    lineDash: 'Line Dash',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    combinationGroup: 'Combination',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    columnLineComboTooltip: 'Column & Line',
    areaColumnComboTooltip: 'Area & Column',
    customComboTooltip: 'Custom Combination',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart',
    seriesChartType: 'Series Chart Type',
    seriesType: 'Series Type',
    secondaryAxis: 'Secondary Axis',

    // ARIA
    ariaAdvancedFilterBuilderItem: '${variable1}. Level ${variable2}. Press ENTER to edit.',
    ariaAdvancedFilterBuilderItemValidation: '${variable1}. Level ${variable2}. ${variable3} Press ENTER to edit.',
    ariaAdvancedFilterBuilderList: 'Advanced Filter Builder List',
    ariaAdvancedFilterBuilderFilterItem: 'Filter Condition',
    ariaAdvancedFilterBuilderGroupItem: 'Filter Group',
    ariaAdvancedFilterBuilderColumn: 'Column',
    ariaAdvancedFilterBuilderOption: 'Option',
    ariaAdvancedFilterBuilderValueP: 'Value',
    ariaAdvancedFilterBuilderJoinOperator: 'Join Operator',
    ariaAdvancedFilterInput: 'Advanced Filter Input',
    ariaChecked: 'checked',
    ariaColumn: 'Column',
    ariaColumnGroup: 'Column Group',
    ariaColumnList: 'Column List',
    ariaColumnSelectAll: 'Toggle Select All Columns',
    ariaDateFilterInput: 'Date Filter Input',
    ariaDefaultListName: 'List',
    ariaFilterColumnsInput: 'Filter Columns Input',
    ariaFilterFromValue: 'Filter from value',
    ariaFilterInput: 'Filter Input',
    ariaFilterList: 'Filter List',
    ariaFilterToValue: 'Filter to value',
    ariaFilterValue: 'Filter Value',
    ariaFilterMenuOpen: 'Open Filter Menu',
    ariaFilteringOperator: 'Filtering Operator',
    ariaHidden: 'hidden',
    ariaIndeterminate:'indeterminate',
    ariaInputEditor: 'Input Editor',
    ariaMenuColumn: 'Press CTRL ENTER to open column menu.',
    ariaRowDeselect: 'Press SPACE to deselect this row',
    ariaRowSelectAll: 'Press Space to toggle all rows selection',
    ariaRowToggleSelection: 'Press Space to toggle row selection',
    ariaRowSelect: 'Press SPACE to select this row',
    ariaSearch: 'Search',
    ariaSortableColumn: 'Press ENTER to sort',
    ariaToggleVisibility: 'Press SPACE to toggle visibility',
    ariaToggleCellValue: 'Press SPACE to toggle cell value',
    ariaUnchecked: 'unchecked',
    ariaVisible: 'visible',
    ariaSearchFilterValues: 'Search filter values',

    // ARIA Labels for Drop Zones

    ariaRowGroupDropZonePanelLabel: 'Row Groups',
    ariaValuesDropZonePanelLabel: 'Values',
    ariaPivotDropZonePanelLabel: 'Column Labels',
    ariaDropZoneColumnComponentDescription: 'Press DELETE to remove',
    ariaDropZoneColumnValueItemDescription: 'Press ENTER to change the aggregation type',
    ariaDropZoneColumnGroupItemDescription: 'Press ENTER to sort',
    // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
    ariaDropZoneColumnComponentAggFuncSeparator: ' of ',
    ariaDropZoneColumnComponentSortAscending: 'ascending',
    ariaDropZoneColumnComponentSortDescending: 'descending',

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: 'Column Menu',
    ariaLabelCellEditor: 'Cell Editor',
    ariaLabelDialog: 'Dialog',
    ariaLabelSelectField: 'Select Field',
    ariaLabelRichSelectField: 'Rich Select Field',
    ariaLabelTooltip: 'Tooltip',
    ariaLabelContextMenu: 'Context Menu',
    ariaLabelSubMenu: 'SubMenu',
    ariaLabelAggregationFunction: 'Aggregation Function',
    ariaLabelAdvancedFilterAutocomplete: 'Advanced Filter Autocomplete',
    ariaLabelAdvancedFilterBuilderAddField: 'Advanced Filter Builder Add Field',
    ariaLabelAdvancedFilterBuilderColumnSelectField: 'Advanced Filter Builder Column Select Field',
    ariaLabelAdvancedFilterBuilderOptionSelectField: 'Advanced Filter Builder Option Select Field',
    ariaLabelAdvancedFilterBuilderJoinSelectField: 'Advanced Filter Builder Join Operator Select Field',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ',',
    decimalSeparator: '.',

    // Data types
    true: 'True',
    false: 'False',
    invalidDate: 'Invalid Date',
    invalidNumber: 'Invalid Number',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
};

var fi = {
    // Set Filter
    selectAll: '(Valitse kaikki)',
    selectAllSearchResults: '(Valitse kaikki hakutulokset)',
    addCurrentSelectionToFilter: 'Lisää nykyinen valinta suodattimeen',
    searchOoo: 'Haku...',
    blanks: '(Tyhjät)',
    noMatches: 'Ei osumia',

    // Number Filter & Text Filter
    filterOoo: 'Suodatin...',
    equals: 'Yhtä suuri kuin',
    notEqual: 'Ei yhtä suuri kuin',
    blank: 'Tyhjä',
    notBlank: 'Ei tyhjä',
    empty: 'Valitse yksi',

    // Number Filter
    lessThan: 'Vähemmän kuin',
    greaterThan: 'Enemmän kuin',
    lessThanOrEqual: 'Vähemmän tai yhtä suuri kuin',
    greaterThanOrEqual: 'Enemmän tai yhtä suuri kuin',
    inRange: 'Välillä',
    inRangeStart: 'alkaen',
    inRangeEnd: 'loppuen',

    // Text Filter
    contains: 'Sisältää',
    notContains: 'Ei sisällä',
    startsWith: 'Aloittuu',
    endsWith: 'Päättyy',

    // Date Filter
    dateFormatOoo: 'vvvv-kk-pp',
    before: 'Ennen',
    after: 'Jälkeen',

    // Filter Conditions
    andCondition: 'JA',
    orCondition: 'TAI',

    // Filter Buttons
    applyFilter: 'Käytä',
    resetFilter: 'Nollaa',
    clearFilter: 'Tyhjennä',
    cancelFilter: 'Peruuta',

    // Filter Titles
    textFilter: 'Tekstisuodatin',
    numberFilter: 'Numerosuodatin',
    dateFilter: 'Päiväysuodatin',
    setFilter: 'Aseta suodatin',

    // Group Column Filter
    groupFilterSelect: 'Valitse kenttä:',

    // Advanced Filter
    advancedFilterContains: 'sisältää',
    advancedFilterNotContains: 'ei sisällä',
    advancedFilterTextEquals: 'on yhtä suuri kuin',
    advancedFilterTextNotEqual: 'ei ole yhtä suuri kuin',
    advancedFilterStartsWith: 'alkaa',
    advancedFilterEndsWith: 'päättyy',
    advancedFilterBlank: 'on tyhjä',
    advancedFilterNotBlank: 'ei ole tyhjä',
    advancedFilterEquals: '=',
    advancedFilterNotEqual: '!=',
    advancedFilterGreaterThan: '>',
    advancedFilterGreaterThanOrEqual: '>=',
    advancedFilterLessThan: '<',
    advancedFilterLessThanOrEqual: '<=',
    advancedFilterTrue: 'on tosi',
    advancedFilterFalse: 'on epätosi',
    advancedFilterAnd: 'JA',
    advancedFilterOr: 'TAI',
    advancedFilterApply: 'Käytä',
    advancedFilterBuilder: 'Rakentaja',
    advancedFilterValidationMissingColumn: 'Kenttä puuttuu',
    advancedFilterValidationMissingOption: 'Valinta puuttuu',
    advancedFilterValidationMissingValue: 'Arvo puuttuu',
    advancedFilterValidationInvalidColumn: 'Kenttää ei löydy',
    advancedFilterValidationInvalidOption: 'Valintaa ei löydy',
    advancedFilterValidationMissingQuote: 'Arvosta puuttuu lopetuskaksoispiste',
    advancedFilterValidationNotANumber: 'Arvo ei ole numero',
    advancedFilterValidationInvalidDate: 'Arvo ei ole kelvollinen päivämäärä',
    advancedFilterValidationMissingCondition: 'Ehto puuttuu',
    advancedFilterValidationJoinOperatorMismatch: 'Liittymisoperaattorit ehtojen sisällä on oltava samat',
    advancedFilterValidationInvalidJoinOperator: 'Liittymisoperaattoria ei löydy',
    advancedFilterValidationMissingEndBracket: 'Loppu sulkeva hakasulje puuttuu',
    advancedFilterValidationExtraEndBracket: 'Liian monta loppu sulkevaa hakasuljetta',
    advancedFilterValidationMessage: 'Ilmauksessa on virhe. ${variable1} - ${variable2}.',
    advancedFilterValidationMessageAtEnd: 'Ilmauksessa on virhe. ${variable} ilmauksen lopussa.',
    advancedFilterBuilderTitle: 'Edistynyt suodatin',
    advancedFilterBuilderApply: 'Käytä',
    advancedFilterBuilderCancel: 'Peruuta',
    advancedFilterBuilderAddButtonTooltip: 'Lisää suodatin tai ryhmä',
    advancedFilterBuilderRemoveButtonTooltip: 'Poista',
    advancedFilterBuilderMoveUpButtonTooltip: 'Siirrä ylös',
    advancedFilterBuilderMoveDownButtonTooltip: 'Siirrä alas',
    advancedFilterBuilderAddJoin: 'Lisää ryhmä',
    advancedFilterBuilderAddCondition: 'Lisää suodatin',
    advancedFilterBuilderSelectColumn: 'Valitse kenttä',
    advancedFilterBuilderSelectOption: 'Valitse valinta',
    advancedFilterBuilderEnterValue: 'Syötä arvo...',
    advancedFilterBuilderValidationAlreadyApplied: 'Nykyinen suodatin on jo käytössä.',
    advancedFilterBuilderValidationIncomplete: 'Kaikki ehdot eivät ole valmiita.',
    advancedFilterBuilderValidationSelectColumn: 'Sinun on valittava kenttä.',
    advancedFilterBuilderValidationSelectOption: 'Sinun on valittava valinta.',
    advancedFilterBuilderValidationEnterValue: 'Sinun on syötettävä arvo.',

    // Side Bar
    columns: 'Sarakkeet',
    filters: 'Suodattimet',
    actions: 'Rivitoiminnot',

    // columns tool panel
    pivotMode: 'Pivot-tila',
    groups: 'Ryhmäsarakkeet',
    rowGroupColumnsEmptyMessage: 'Vedä tähän asettaaksesi rivi ryhmäsarakkeet',
    values: 'Arvot',
    valueColumnsEmptyMessage: 'Vedä tähän kootaksesi',
    pivots: 'Sarakemerkinnät',
    pivotColumnsEmptyMessage: 'Vedä tähän asettaaksesi sarakemerkinnät',

    // Header of the Default Group Column
    group: 'Ryhmä',

    // Row Drag
    rowDragRow: 'rivi',
    rowDragRows: 'rivit',

    // Other
    loadingOoo: 'Ladataan...',
    loadingError: 'VIRHE',
    noRowsToShow: 'Ei näytettäviä rivejä',
    enabled: 'Käytössä',

    // Menu
    pinColumn: 'Kiinnitä sarake',
    pinLeft: 'Kiinnitä vasemmalle',
    pinRight: 'Kiinnitä oikealle',
    noPin: 'Ei kiinnitystä',
    valueAggregation: 'Arvon kokoaminen',
    noAggregation: 'Ei kokoamista',
    autosizeThiscolumn: 'Mukauta tämä sarake automaattisesti',
    autosizeAllColumns: 'Mukauta kaikki sarakkeet automaattisesti',
    groupBy: 'Ryhmä',
    ungroupBy: 'Peru ryhmittely',
    ungroupAll: 'Peru kaikki ryhmittelyt',
    addToValues: 'Lisää ${variable} arvoihin',
    removeFromValues: 'Poista ${variable} arvoista',
    addToLabels: 'Lisää ${variable} merkintöihin',
    removeFromLabels: 'Poista ${variable} merkinnöistä',
    resetColumns: 'Palauta sarakkeet',
    expandAll: 'Laajenna kaikki ryhmäryhmät',
    collapseAll: 'Kutista kaikki ryhmäryhmät',
    copy: 'Kopioi',
    ctrlC: 'Ctrl+C',
    ctrlX: 'Ctrl+X',
    copyWithHeaders: 'Kopioi otsikot',
    copyWithGroupHeaders: 'Kopioi ryhmäotsikot',
    cut: 'Leikkaa',
    paste: 'Liitä',
    ctrlV: 'Ctrl+V',
    export: 'Vie',
    csvExport: 'CSV-vienti',
    excelExport: 'Excel-vienti',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Summa',
    first: 'Ensimmäinen',
    last: 'Viimeinen',
    min: 'Minimi',
    max: 'Maksimi',
    none: 'Ei mitään',
    count: 'Lukumäärä',
    avg: 'Keskiarvo',
    filteredRows: 'Suodatetut',
    selectedRows: 'Valitut',
    totalRows: 'Kaikki rivit',
    totalAndFilteredRows: 'Rivit',
    more: 'Lisää',
    to: '-',
    of: '/',
    page: 'Sivu',
    pageLastRowUnknown: '?',
    nextPage: 'Seuraava sivu',
    lastPage: 'Viimeinen sivu',
    firstPage: 'Ensimmäinen sivu',
    previousPage: 'Edellinen sivu',

    // Pivoting
    pivotColumnGroupTotals: 'Yhteensä',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot-kaavio ja Pivot-tila',
    pivotChart: 'Pivot-kaavio',
    chartRange: 'Kaavion alue',

    columnChart: 'Pylväs',
    groupedColumn: 'Ryhmätyt',
    stackedColumn: 'Pinottu',
    normalizedColumn: '100 % pinottu',

    barChart: 'Palkki',
    groupedBar: 'Ryhmätyt',
    stackedBar: 'Pinottu',
    normalizedBar: '100 % pinottu',

    pieChart: 'Ympyrä',
    pie: 'Ympyrä',
    doughnut: 'Donitsi',

    line: 'Viiva',

    xyChart: 'X Y (Hajonta)',
    scatter: 'Hajonta',
    bubble: 'Kupla',

    areaChart: 'Alue',
    area: 'Alue',
    stackedArea: 'Pinottu',
    normalizedArea: '100 % pinottu',

    histogramChart: 'Histogrammi',
    histogramFrequency: 'Taajuus',

    combinationChart: 'Yhdistelmä',
    columnLineCombo: 'Pylväs ja viiva',
    AreaColumnCombo: 'Alue ja pylväs',

    // Charts
    pivotChartTitle: 'Pivot-kaavio',
    rangeChartTitle: 'Aikasarjakaavio',
    settings: 'Asetukset',
    data: 'Tiedot',
    format: 'Muotoilu',
    categories: 'Kategoriat',
    defaultCategory: '(Ei valittu)',
    series: 'Sarjat',
    xyValues: 'X Y arvot',
    paired: 'Paritila',
    axis: 'Akseli',
    navigator: 'Navigaattori',
    color: 'Väri',
    thickness: 'Paksuus',
    xType: 'X-tyyppi',
    automatic: 'Automaattinen',
    category: 'Kategoria',
    number: 'Numero',
    time: 'Aika',
    autoRotate: 'Automaattinen kierto',
    xRotation: 'X-käännös',
    yRotation: 'Y-käännös',
    ticks: 'Viivat',
    width: 'Leveys',
    height: 'Korkeus',
    length: 'Pituus',
    padding: 'Täyttö',
    spacing: 'Väli',
    chart: 'Kaavio',
    title: 'Otsikko',
    titlePlaceholder: 'Kaavion otsikko - kaksoisnapsauta muokataksesi',
    background: 'Tausta',
    font: 'Kirjasin',
    top: 'Ylhäältä',
    right: 'Oikealta',
    bottom: 'Alhaalta',
    left: 'Vasemmalta',
    labels: 'Tarrat',
    size: 'Koko',
    minSize: 'Vähimmäiskoko',
    maxSize: 'Suurin koko',
    legend: 'Selite',
    position: 'Sijainti',
    markerSize: 'Merkin koko',
    markerStroke: 'Merkin ääriviiva',
    markerPadding: 'Merkin täyttö',
    itemSpacing: 'Kohteen väli',
    itemPaddingX: 'Kohteen täyttö X',
    itemPaddingY: 'Kohteen täyttö Y',
    layoutHorizontalSpacing: 'Vaakasuuntainen väli',
    layoutVerticalSpacing: 'Pystysuuntainen väli',
    strokeWidth: 'Viivan leveys',
    lineDash: 'Viivan katkoviiva',
    offset: 'Poikkeama',
    offsets: 'Poikkeamat',
    tooltips: 'Työkaluvihjeet',
    callout: 'Huomautus',
    markers: 'Merkit',
    shadow: 'Varjo',
    blur: 'Sumennus',
    xOffset: 'X-poikkeama',
    yOffset: 'Y-poikkeama',
    lineWidth: 'Viivan leveys',
    normal: 'Normaali',
    bold: 'Lihavoitu',
    italic: 'Kursivoitu',
    boldItalic: 'Lihavoitu ja kursivoitu',
    predefined: 'Esiasetettu',
    fillOpacity: 'Täytön peittävyys',
    strokeOpacity: 'Viivan peittävyys',
    histogramBinCount: 'Luokkaväli laskenta',
    columnGroup: 'Pylväs',
    barGroup: 'Palkki',
    pieGroup: 'Ympyrä',
    lineGroup: 'Viiva',
    scatterGroup: 'X Y (Hajonta)',
    areaGroup: 'Alue',
    histogramGroup: 'Histogrammi',
    combinationGroup: 'Yhdistelmä',
    groupedColumnTooltip: 'Ryhmätyt',
    stackedColumnTooltip: 'Pinottu',
    normalizedColumnTooltip: '100 % pinottu',
    groupedBarTooltip: 'Ryhmätyt',
    stackedBarTooltip: 'Pinottu',
    normalizedBarTooltip: '100 % pinottu',
    pieTooltip: 'Ympyrä',
    doughnutTooltip: 'Donitsi',
    lineTooltip: 'Viiva',
    groupedAreaTooltip: 'Alue',
    stackedAreaTooltip: 'Pinottu',
    normalizedAreaTooltip: '100 % pinottu',
    scatterTooltip: 'Hajonta',
    bubbleTooltip: 'Kupla',
    histogramTooltip: 'Histogrammi',
    columnLineComboTooltip: 'Pylväs ja viiva',
    areaColumnComboTooltip: 'Alue ja pylväs',
    customComboTooltip: 'Mukautettu yhdistelmä',
    noDataToChart: 'Ei saatavilla olevia tietoja kaaviointiin.',
    pivotChartRequiresPivotMode: 'Pivot-kaavio vaatii Pivot-tilan käytössä.',
    chartSettingsToolbarTooltip: 'Valikko',
    chartLinkToolbarTooltip: 'Liitetty ruudukkoon',
    chartUnlinkToolbarTooltip: 'Irrotettu ruudukosta',
    chartDownloadToolbarTooltip: 'Lataa kaavio',
    seriesChartType: 'Sarjan kaaviotyyppi',
    seriesType: 'Sarjan tyyppi',
    secondaryAxis: 'Toissijainen akseli',

    // ARIA
    ariaAdvancedFilterBuilderItem: '${variable1}. Taso ${variable2}. Paina ENTER muokataksesi.',
    ariaAdvancedFilterBuilderItemValidation: '${variable1}. Taso ${variable2}. ${variable3} Paina ENTER muokataksesi.',
    ariaAdvancedFilterBuilderList: 'Edistynyt suodatinrakentimen lista',
    ariaAdvancedFilterBuilderFilterItem: 'Suodatin ehto',
    ariaAdvancedFilterBuilderGroupItem: 'Suodatin ryhmä',
    ariaAdvancedFilterBuilderColumn: 'Sarake',
    ariaAdvancedFilterBuilderOption: 'Valinta',
    ariaAdvancedFilterBuilderValueP: 'Arvo',
    ariaAdvancedFilterBuilderJoinOperator: 'Liittymisoperaattori',
    ariaAdvancedFilterInput: 'Edistynyt suodatin syöte',
    ariaChecked: 'valittu',
    ariaColumn: 'Sarake',
    ariaColumnGroup: 'Sarakeryhmä',
    ariaColumnList: 'Sarakelista',
    ariaColumnSelectAll: 'Valitse kaikki sarakkeet',
    ariaDateFilterInput: 'Päiväys suodatin syöte',
    ariaDefaultListName: 'Luettelo',
    ariaFilterColumnsInput: 'Suodatinsarakkeet syöte',
    ariaFilterFromValue: 'Suodatusarvo alkaen',
    ariaFilterInput: 'Suodatus syöte',
    ariaFilterList: 'Suodatusluettelo',
    ariaFilterToValue: 'Suodatusarvo loppuen',
    ariaFilterValue: 'Suodatusarvo',
    ariaFilterMenuOpen: 'Avaa suodatusvalikko',
    ariaFilteringOperator: 'Suodatusoperaattori',
    ariaHidden: 'piilotettu',
    ariaIndeterminate: 'epämääräinen',
    ariaInputEditor: 'Syöttömuokkain',
    ariaMenuColumn: 'Paina CTRL ENTER avataksesi sarakkeen valikon.',
    ariaRowDeselect: 'Paina VÄLINÄPPÄINTÄ poistaaksesi tämä rivi valinnasta',
    ariaRowSelectAll: 'Paina VÄLINÄPPÄINTÄ valitaksesi tai poistaaksesi kaikki rivit',
    ariaRowToggleSelection: 'Paina VÄLINÄPPÄINTÄ kytkeäksesi rivin valinnan päälle tai pois päältä',
    ariaRowSelect: 'Paina VÄLINÄPPÄINTÄ valitaksesi tämä rivi',
    ariaSearch: 'Haku',
    ariaSortableColumn: 'Paina ENTER järjestääksesi',
    ariaToggleVisibility: 'Paina VÄLINÄPPÄINTÄ näkyvyyden vaihtamiseksi',
    ariaToggleCellValue: 'Paina VÄLINÄPPÄINTÄ soluarvon vaihtamiseksi',
    ariaUnchecked: 'valitsematon',
    ariaVisible: 'näkyvä',
    ariaSearchFilterValues: 'Haku suodatusarvoja',

    // ARIA Labels for Drop Zones

    ariaRowGroupDropZonePanelLabel: 'Ryhmäsarakkeet',
    ariaValuesDropZonePanelLabel: 'Arvot',
    ariaPivotDropZonePanelLabel: 'Sarakemerkinnät',
    ariaDropZoneColumnComponentDescription: 'Paina DELETE poistaaksesi',
    ariaDropZoneColumnValueItemDescription: 'Paina ENTER muuttaaksesi kokoamistyyppiä',
    ariaDropZoneColumnGroupItemDescription: 'Paina ENTER järjestääksesi',
    // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
    ariaDropZoneColumnComponentAggFuncSeparator: ' kohteesta ',
    ariaDropZoneColumnComponentSortAscending: 'nousevasti',
    ariaDropZoneColumnComponentSortDescending: 'laskevasti',

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: 'Sarakkeiden valikko',
    ariaLabelCellEditor: 'Solun muokkaus',
    ariaLabelDialog: 'Valintaikkuna',
    ariaLabelSelectField: 'Valintakenttä',
    ariaLabelRichSelectField: 'Monipuolinen valintakenttä',
    ariaLabelTooltip: 'Työkalun kärki',
    ariaLabelContextMenu: 'Kontekstivalikko',
    ariaLabelSubMenu: 'Alivalikko',
    ariaLabelAggregationFunction: 'Yhdistämistoiminto',
    ariaLabelAdvancedFilterAutocomplete: 'Edistynyt suodattimen automaattihaku',
    ariaLabelAdvancedFilterBuilderAddField: 'Lisää kenttä edistyneeseen suodattimen rakentajaan',
    ariaLabelAdvancedFilterBuilderColumnSelectField: 'Sarakkeen valinta edistyneessä suodattimen rakentajassa',
    ariaLabelAdvancedFilterBuilderOptionSelectField: 'Vaihtoehdon valinta edistyneessä suodattimen rakentajassa',
    ariaLabelAdvancedFilterBuilderJoinSelectField: 'Liitosoperaattorin valinta edistyneessä suodattimen rakentajassa',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ' ',
    decimalSeparator: ',',

    // Data types
    true: 'Tosi',
    false: 'Epätosi',
    invalidDate: 'Virheellinen päivämäärä',
    invalidNumber: 'Virheellinen numero',
    january: 'Tammikuu',
    february: 'Helmikuu',
    march: 'Maaliskuu',
    april: 'Huhtikuu',
    may: 'Toukokuu',
    june: 'Kesäkuu',
    july: 'Heinäkuu',
    august: 'Elokuu',
    september: 'Syyskuu',
    october: 'Lokakuu',
    november: 'Marraskuu',
    december: 'Joulukuu',
};

var sv = {
    // Set Filter
    selectAll: '(Välj Alla)',
    selectAllSearchResults: '(Välj Alla Sökresultat)',
    addCurrentSelectionToFilter: 'Lägg till aktuell markering i filtret',
    searchOoo: 'Sök...',
    blanks: '(Tomma)',
    noMatches: 'Inga träffar',

    // Number Filter & Text Filter
    filterOoo: 'Filtrera...',
    equals: 'Lika med',
    notEqual: 'Inte lika med',
    blank: 'Tom',
    notBlank: 'Inte tom',
    empty: 'Välj en',

    // Number Filter
    lessThan: 'Mindre än',
    greaterThan: 'Större än',
    lessThanOrEqual: 'Mindre än eller lika med',
    greaterThanOrEqual: 'Större än eller lika med',
    inRange: 'Inom intervallet',
    inRangeStart: 'från',
    inRangeEnd: 'till',

    // Text Filter
    contains: 'Innehåller',
    notContains: 'Innehåller inte',
    startsWith: 'Börjar med',
    endsWith: 'Slutar med',

    // Date Filter
    dateFormatOoo: 'åååå-mm-dd',
    before: "Före",
    after: "Efter",

    // Filter Conditions
    andCondition: 'OCH',
    orCondition: 'ELLER',

    // Filter Buttons
    applyFilter: 'Tillämpa',
    resetFilter: 'Återställ',
    clearFilter: 'Rensa',
    cancelFilter: 'Avbryt',

    // Filter Titles
    textFilter: 'Textfilter',
    numberFilter: 'Numeriskt filter',
    dateFilter: 'Datumfilter',
    setFilter: 'Ställ in filter',

    // Group Column Filter
    groupFilterSelect: 'Välj fält:',

    // Advanced Filter
    advancedFilterContains: 'innehåller',
    advancedFilterNotContains: 'innehåller inte',
    advancedFilterTextEquals: 'är lika med',
    advancedFilterTextNotEqual: 'är inte lika med',
    advancedFilterStartsWith: 'börjar med',
    advancedFilterEndsWith: 'slutar med',
    advancedFilterBlank: 'är tomt',
    advancedFilterNotBlank: 'är inte tomt',
    advancedFilterEquals: '=',
    advancedFilterNotEqual: '!=',
    advancedFilterGreaterThan: '>',
    advancedFilterGreaterThanOrEqual: '>=',
    advancedFilterLessThan: '<',
    advancedFilterLessThanOrEqual: '<=',
    advancedFilterTrue: 'är sant',
    advancedFilterFalse: 'är falskt',
    advancedFilterAnd: 'OCH',
    advancedFilterOr: 'ELLER',
    advancedFilterApply: 'Tillämpa',
    advancedFilterBuilder: 'Byggare',
    advancedFilterValidationMissingColumn: 'Fält saknas',
    advancedFilterValidationMissingOption: 'Alternativ saknas',
    advancedFilterValidationMissingValue: 'Värde saknas',
    advancedFilterValidationInvalidColumn: 'Fältet hittades inte',
    advancedFilterValidationInvalidOption: 'Alternativet hittades inte',
    advancedFilterValidationMissingQuote: 'Värdet saknar avslutande citattecken',
    advancedFilterValidationNotANumber: 'Värdet är inte ett nummer',
    advancedFilterValidationInvalidDate: 'Värdet är inte ett giltigt datum',
    advancedFilterValidationMissingCondition: 'Villkoret saknas',
    advancedFilterValidationJoinOperatorMismatch: 'Sammanfogningsoperatorer inom ett villkor måste vara desamma',
    advancedFilterValidationInvalidJoinOperator: 'Sammanfogningsoperatorn hittades inte',
    advancedFilterValidationMissingEndBracket: 'Saknar avslutande parentes',
    advancedFilterValidationExtraEndBracket: 'För många avslutande parenteser',
    advancedFilterValidationMessage: 'Uttrycket har ett fel. ${variable1} - ${variable2}.',
    advancedFilterValidationMessageAtEnd: 'Uttrycket har ett fel. ${variable} i slutet av uttrycket.',
    advancedFilterBuilderTitle: 'Avancerat filter',
    advancedFilterBuilderApply: 'Tillämpa',
    advancedFilterBuilderCancel: 'Avbryt',
    advancedFilterBuilderAddButtonTooltip: 'Lägg till filter eller grupp',
    advancedFilterBuilderRemoveButtonTooltip: 'Ta bort',
    advancedFilterBuilderMoveUpButtonTooltip: 'Flytta uppåt',
    advancedFilterBuilderMoveDownButtonTooltip: 'Flytta nedåt',
    advancedFilterBuilderAddJoin: 'Lägg till grupp',
    advancedFilterBuilderAddCondition: 'Lägg till filter',
    advancedFilterBuilderSelectColumn: 'Välj ett fält',
    advancedFilterBuilderSelectOption: 'Välj ett alternativ',
    advancedFilterBuilderEnterValue: 'Ange ett värde...',
    advancedFilterBuilderValidationAlreadyApplied: 'Aktuellt filter har redan tillämpats.',
    advancedFilterBuilderValidationIncomplete: 'Inte alla villkor är kompletta.',
    advancedFilterBuilderValidationSelectColumn: 'Måste välja ett fält.',
    advancedFilterBuilderValidationSelectOption: 'Måste välja ett alternativ.',
    advancedFilterBuilderValidationEnterValue: 'Måste ange ett värde.',

    // Side Bar
    columns: 'Kolumner',
    filters: 'Filter',
    actions: 'Åtgärdsknappar',

    // columns tool panel
    pivotMode: 'Pivotläge',
    groups: 'Radgrupper',
    rowGroupColumnsEmptyMessage: 'Dra hit för att ställa in radgrupper',
    values: 'Värden',
    valueColumnsEmptyMessage: 'Dra hit för att aggregera',
    pivots: 'Kolumnetiketter',
    pivotColumnsEmptyMessage: 'Dra hit för att ställa in kolumnetiketter',

    // Header of the Default Group Column
    group: 'Grupp',

    // Row Drag
    rowDragRow: 'rad',
    rowDragRows: 'rader',

    // Other
    loadingOoo: 'Laddar...',
    loadingError: 'FEL',
    noRowsToShow: 'Inga rader att visa',
    enabled: 'Aktiverad',

    // Menu
    pinColumn: 'Fäst kolumn',
    pinLeft: 'Fäst till vänster',
    pinRight: 'Fäst till höger',
    noPin: 'Ingen fästning',
    valueAggregation: 'Värdeaggregering',
    noAggregation: 'Ingen',
    autosizeThiscolumn: 'Autostorlek för denna kolumn',
    autosizeAllColumns: 'Autostorlek för alla kolumner',
    groupBy: 'Gruppera efter',
    ungroupBy: 'Avgruppera',
    ungroupAll: 'Avgruppera alla',
    addToValues: 'Lägg till ${variable} i värden',
    removeFromValues: 'Ta bort ${variable} från värden',
    addToLabels: 'Lägg till ${variable} i etiketter',
    removeFromLabels: 'Ta bort ${variable} från etiketter',
    resetColumns: 'Återställ kolumner',
    expandAll: 'Expandera alla radgrupper',
    collapseAll: 'Stäng alla radgrupper',
    copy: 'Kopiera',
    ctrlC: 'Ctrl+C',
    ctrlX: 'Ctrl+X',
    copyWithHeaders: 'Kopiera med rubriker',
    copyWithGroupHeaders: 'Kopiera med grupprubriker',
    cut: 'Klipp',
    paste: 'Klistra in',
    ctrlV: 'Ctrl+V',
    export: 'Exportera',
    csvExport: 'CSV-export',
    excelExport: 'Excel-export',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Summa',
    first: 'Första',
    last: 'Sista',
    min: 'Min',
    max: 'Max',
    none: 'Ingen',
    count: 'Antal',
    avg: 'Genomsnitt',
    filteredRows: 'Filtrerade',
    selectedRows: 'Valda',
    totalRows: 'Totalt antal rader',
    totalAndFilteredRows: 'rader',
    more: 'Mer',
    to: 'till',
    of: 'av',
    page: 'Sida',
    pageLastRowUnknown: '?',
    nextPage: 'Nästa sida',
    lastPage: 'Sista sidan',
    firstPage: 'Första sidan',
    previousPage: 'Föregående sida',

    // Pivoting
    pivotColumnGroupTotals: 'Total',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivotdiagram & Pivotläge',
    pivotChart: 'Pivotdiagram',
    chartRange: 'Diagramområde',

    columnChart: 'Kolumn',
    groupedColumn: 'Grupperad',
    stackedColumn: 'Staplad',
    normalizedColumn: '100% Staplad',

    barChart: 'Stapeldiagram',
    groupedBar: 'Grupperad',
    stackedBar: 'Staplad',
    normalizedBar: '100% Staplad',

    pieChart: 'Pajdiagram',
    pie: 'Paj',
    doughnut: 'Ringdiagram',

    line: 'Linje',

    xyChart: 'X Y (Spridning)',
    scatter: 'Spridning',
    bubble: 'Bubbel',

    areaChart: 'Områdediagram',
    area: 'Område',
    stackedArea: 'Staplad',
    normalizedArea: '100% Staplad',

    histogramChart: 'Histogram',
    histogramFrequency: 'Frekvens',

    combinationChart: 'Kombinationsdiagram',
    columnLineCombo: 'Kolumn & Linje',
    AreaColumnCombo: 'Område & Kolumn',

    // Charts
    pivotChartTitle: 'Pivotdiagram',
    rangeChartTitle: 'Områdediagram',
    settings: 'Inställningar',
    data: 'Data',
    format: 'Format',
    categories: 'Kategorier',
    defaultCategory: '(Ingen)',
    series: 'Serie',
    xyValues: 'X Y-värden',
    paired: 'Parläge',
    axis: 'Axel',
    navigator: 'Navigator',
    color: 'Färg',
    thickness: 'Tjocklek',
    xType: 'X-typ',
    automatic: 'Automatisk',
    category: 'Kategori',
    number: 'Nummer',
    time: 'Tid',
    autoRotate: 'Automatisk rotation',
    xRotation: 'X-rotation',
    yRotation: 'Y-rotation',
    ticks: 'Markeringar',
    width: 'Bredd',
    height: 'Höjd',
    length: 'Längd',
    padding: 'Marginal',
    spacing: 'Avstånd',
    chart: 'Diagram',
    title: 'Titel',
    titlePlaceholder: 'Diagramtitel - dubbelklicka för att redigera',
    background: 'Bakgrund',
    font: 'Typsnitt',
    top: 'Överst',
    right: 'Höger',
    bottom: 'Nederst',
    left: 'Vänster',
    labels: 'Etiketter',
    size: 'Storlek',
    minSize: 'Minsta storlek',
    maxSize: 'Största storlek',
    legend: 'Teckenförklaring',
    position: 'Position',
    markerSize: 'Markörstorlek',
    markerStroke: 'Markörkontur',
    markerPadding: 'Markörmarginal',
    itemSpacing: 'Elementavstånd',
    itemPaddingX: 'Elementmarginal X',
    itemPaddingY: 'Elementmarginal Y',
    layoutHorizontalSpacing: 'Horisontellt avstånd',
    layoutVerticalSpacing: 'Vertikalt avstånd',
    strokeWidth: 'Linjetjocklek',
    lineDash: 'Linjestreck',
    offset: 'Förskjutning',
    offsets: 'Förskjutningar',
    tooltips: 'Verktygstips',
    callout: 'Callout',
    markers: 'Markörer',
    shadow: 'Skugga',
    blur: 'Osäm',
    xOffset: 'X-förskjutning',
    yOffset: 'Y-förskjutning',
    lineWidth: 'Linjebredd',
    normal: 'Normal',
    bold: 'Fet',
    italic: 'Kursiv',
    boldItalic: 'Fet kursiv',
    predefined: 'Fördefinierad',
    fillOpacity: 'Fyllnadsopacitet',
    strokeOpacity: 'Linjeopacitet',
    histogramBinCount: 'Antal staplar',
    columnGroup: 'Kolumn',
    barGroup: 'Stapeldiagram',
    pieGroup: 'Pajdiagram',
    lineGroup: 'Linjediagram',
    scatterGroup: 'X Y (Spridning)',
    areaGroup: 'Områdediagram',
    histogramGroup: 'Histogram',
    combinationGroup: 'Kombinationsdiagram',
    groupedColumnTooltip: 'Grupperad',
    stackedColumnTooltip: 'Staplad',
    normalizedColumnTooltip: '100% Staplad',
    groupedBarTooltip: 'Grupperad',
    stackedBarTooltip: 'Staplad',
    normalizedBarTooltip: '100% Staplad',
    pieTooltip: 'Paj',
    doughnutTooltip: 'Ringdiagram',
    lineTooltip: 'Linje',
    groupedAreaTooltip: 'Område',
    stackedAreaTooltip: 'Staplad',
    normalizedAreaTooltip: '100% Staplad',
    scatterTooltip: 'Spridning',
    bubbleTooltip: 'Bubbel',
    histogramTooltip: 'Histogram',
    columnLineComboTooltip: 'Kolumn & Linje',
    areaColumnComboTooltip: 'Område & Kolumn',
    customComboTooltip: 'Anpassad kombination',
    noDataToChart: 'Inga data tillgängliga för diagram.',
    pivotChartRequiresPivotMode: 'Pivotdiagram kräver aktiverat pivotläge.',
    chartSettingsToolbarTooltip: 'Meny',
    chartLinkToolbarTooltip: 'Länkad till rutnätet',
    chartUnlinkToolbarTooltip: 'Ej länkad till rutnätet',
    chartDownloadToolbarTooltip: 'Ladda ner diagram',
    seriesChartType: 'Seriediagramtyp',
    seriesType: 'Seriens typ',
    secondaryAxis: 'Sekundär axel',

    // ARIA
    ariaAdvancedFilterBuilderItem: '${variable1}. Nivå ${variable2}. Tryck på ENTER för att redigera.',
    ariaAdvancedFilterBuilderItemValidation: '${variable1}. Nivå ${variable2}. ${variable3} Tryck på ENTER för att redigera.',
    ariaAdvancedFilterBuilderList: 'Avancerad filterbyggare',
    ariaAdvancedFilterBuilderFilterItem: 'Filtervillkor',
    ariaAdvancedFilterBuilderGroupItem: 'Filtergrupp',
    ariaAdvancedFilterBuilderColumn: 'Kolumn',
    ariaAdvancedFilterBuilderOption: 'Alternativ',
    ariaAdvancedFilterBuilderValueP: 'Värde',
    ariaAdvancedFilterBuilderJoinOperator: 'Sammanfogningsoperator',
    ariaAdvancedFilterInput: 'Avancerad filterinmatning',
    ariaChecked: 'markerad',
    ariaColumn: 'Kolumn',
    ariaColumnGroup: 'Kolumngrupp',
    ariaColumnList: 'Kolumnlista',
    ariaColumnSelectAll: 'Växla alla kolumner',
    ariaDateFilterInput: 'Datumfilterinmatning',
    ariaDefaultListName: 'Lista',
    ariaFilterColumnsInput: 'Inmatning av filterkolumner',
    ariaFilterFromValue: 'Filter från värde',
    ariaFilterInput: 'Filterinmatning',
    ariaFilterList: 'Filterlista',
    ariaFilterToValue: 'Filter till värde',
    ariaFilterValue: 'Filtervärde',
    ariaFilterMenuOpen: 'Öppna filtermenyn',
    ariaFilteringOperator: 'Filtreringsoperator',
    ariaHidden: 'dold',
    ariaIndeterminate: 'delvis vald',
    ariaInputEditor: 'Inmatningsredigerare',
    ariaMenuColumn: 'Tryck på CTRL ENTER för att öppna kolumnmenyn.',
    ariaRowDeselect: 'Tryck på MELLANSLAG för att avmarkera denna rad',
    ariaRowSelectAll: 'Tryck på MELLANSLAG för att växla markering av alla rader',
    ariaRowToggleSelection: 'Tryck på MELLANSLAG för att växla markering av rad',
    ariaRowSelect: 'Tryck på MELLANSLAG för att markera denna rad',
    ariaSearch: 'Sök',
    ariaSortableColumn: 'Tryck på ENTER för att sortera',
    ariaToggleVisibility: 'Tryck på MELLANSLAG för att växla synlighet',
    ariaToggleCellValue: 'Tryck på MELLANSLAG för att växla cellvärde',
    ariaUnchecked: 'omarkerad',
    ariaVisible: 'synlig',
    ariaSearchFilterValues: 'Sök i filtervärden',

    // ARIA Labels for Drop Zones

    ariaRowGroupDropZonePanelLabel: 'Radgrupper',
    ariaValuesDropZonePanelLabel: 'Värden',
    ariaPivotDropZonePanelLabel: 'Kolumnetiketter',
    ariaDropZoneColumnComponentDescription: 'Tryck på DELETE för att ta bort',
    ariaDropZoneColumnValueItemDescription: 'Tryck på ENTER för att ändra aggregeringstyp',
    ariaDropZoneColumnGroupItemDescription: 'Tryck på ENTER för att sortera',
    // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
    ariaDropZoneColumnComponentAggFuncSeparator: ' av ',
    ariaDropZoneColumnComponentSortAscending: 'stigande',
    ariaDropZoneColumnComponentSortDescending: 'fallande',

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: 'Kolumnmeny',
    ariaLabelCellEditor: 'Cellredigerare',
    ariaLabelDialog: 'Dialog',
    ariaLabelSelectField: 'Välj fält',
    ariaLabelRichSelectField: 'Rik fältväljare',
    ariaLabelTooltip: 'Verktygstips',
    ariaLabelContextMenu: 'Kontextmeny',
    ariaLabelSubMenu: 'Undermeny',
    ariaLabelAggregationFunction: 'Aggregeringsfunktion',
    ariaLabelAdvancedFilterAutocomplete: 'Avancerad filterautofyllning',
    ariaLabelAdvancedFilterBuilderAddField: 'Lägg till fält i avancerad filterbyggare',
    ariaLabelAdvancedFilterBuilderColumnSelectField: 'Välj fält i avancerad filterbyggare',
    ariaLabelAdvancedFilterBuilderOptionSelectField: 'Välj alternativ i avancerad filterbyggare',
    ariaLabelAdvancedFilterBuilderJoinSelectField: 'Välj sammanslagningsoperator i avancerad filterbyggare',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ',',
    decimalSeparator: '.',

    // Data types
    true: 'Sant',
    false: 'Falskt',
    invalidDate: 'Ogiltigt datum',
    invalidNumber: 'Ogiltigt nummer',
    january: 'Januari',
    february: 'Februari',
    march: 'Mars',
    april: 'April',
    may: 'Maj',
    june: 'Juni',
    july: 'Juli',
    august: 'Augusti',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'December',
};

var nl = { // translated with ChatGPT
  // Set Filter
  selectAll: '(Selecteer alles)',
  selectAllSearchResults: '(Selecteer alle zoekresultaten)',
  addCurrentSelectionToFilter: 'Huidige selectie toevoegen aan filter',
  searchOoo: 'Zoeken...',
  blanks: '(Leeg)',
  noMatches: 'Geen overeenkomsten',

  // Number Filter & Text Filter
  filterOoo: 'Filteren...',
  equals: 'Is gelijk aan',
  notEqual: 'Niet gelijk aan',
  blank: 'Leeg',
  notBlank: 'Niet leeg',
  empty: 'Kies een optie',

  // Number Filter
  lessThan: 'Minder dan',
  greaterThan: 'Groter dan',
  lessThanOrEqual: 'Kleiner dan of gelijk aan',
  greaterThanOrEqual: 'Groter dan of gelijk aan',
  inRange: 'In bereik',
  inRangeStart: 'van',
  inRangeEnd: 'tot',

  // Text Filter
  contains: 'Bevat',
  notContains: 'Bevat niet',
  startsWith: 'Begint met',
  endsWith: 'Eindigt met',

  // Date Filter
  dateFormatOoo: 'jjjj-mm-dd',
  before: "Voor",
  after: "Na",

  // Filter Conditions
  andCondition: 'EN',
  orCondition: 'OF',

  // Filter Buttons
  applyFilter: 'Toepassen',
  resetFilter: 'Resetten',
  clearFilter: 'Wissen',
  cancelFilter: 'Annuleren',

  // Filter Titles
  textFilter: 'Tekstfilter',
  numberFilter: 'Nummerfilter',
  dateFilter: 'Datumfilter',
  setFilter: 'Filter instellen',

  // Group Column Filter
  groupFilterSelect: 'Selecteer veld:',

  // Advanced Filter
  advancedFilterContains: 'bevat',
  advancedFilterNotContains: 'bevat niet',
  advancedFilterTextEquals: 'is gelijk aan',
  advancedFilterTextNotEqual: 'is niet gelijk aan',
  advancedFilterStartsWith: 'begint met',
  advancedFilterEndsWith: 'eindigt met',
  advancedFilterBlank: 'is leeg',
  advancedFilterNotBlank: 'is niet leeg',
  advancedFilterEquals: '=',
  advancedFilterNotEqual: '!=',
  advancedFilterGreaterThan: '>',
  advancedFilterGreaterThanOrEqual: '>=',
  advancedFilterLessThan: '<',
  advancedFilterLessThanOrEqual: '<=',
  advancedFilterTrue: 'is waar',
  advancedFilterFalse: 'is onwaar',
  advancedFilterAnd: 'EN',
  advancedFilterOr: 'OF',
  advancedFilterApply: 'Toepassen',
  advancedFilterBuilder: 'Bouwer',
  advancedFilterValidationMissingColumn: 'Kolom ontbreekt',
  advancedFilterValidationMissingOption: 'Optie ontbreekt',
  advancedFilterValidationMissingValue: 'Waarde ontbreekt',
  advancedFilterValidationInvalidColumn: 'Kolom niet gevonden',
  advancedFilterValidationInvalidOption: 'Optie niet gevonden',
  advancedFilterValidationMissingQuote: 'Waarde mist een eindcitaat',
  advancedFilterValidationNotANumber: 'Waarde is geen nummer',
  advancedFilterValidationInvalidDate: 'Waarde is geen geldige datum',
  advancedFilterValidationMissingCondition: 'Voorwaarde ontbreekt',
  advancedFilterValidationJoinOperatorMismatch: 'Verbindingsoperators binnen een voorwaarde moeten hetzelfde zijn',
  advancedFilterValidationInvalidJoinOperator: 'Verbindingsoperator niet gevonden',
  advancedFilterValidationMissingEndBracket: 'Eindhaakje ontbreekt',
  advancedFilterValidationExtraEndBracket: 'Te veel eindhaakjes',
  advancedFilterValidationMessage: 'Expressie bevat een fout. ${variable1} - ${variable2}.',
  advancedFilterValidationMessageAtEnd: 'Expressie bevat een fout. ${variable} aan het einde van de expressie.',
  advancedFilterBuilderTitle: 'Geavanceerd filter',
  advancedFilterBuilderApply: 'Toepassen',
  advancedFilterBuilderCancel: 'Annuleren',
  advancedFilterBuilderAddButtonTooltip: 'Filter of groep toevoegen',
  advancedFilterBuilderRemoveButtonTooltip: 'Verwijderen',
  advancedFilterBuilderMoveUpButtonTooltip: 'Omhoog verplaatsen',
  advancedFilterBuilderMoveDownButtonTooltip: 'Omlaag verplaatsen',
  advancedFilterBuilderAddJoin: 'Groep toevoegen',
  advancedFilterBuilderAddCondition: 'Filter toevoegen',
  advancedFilterBuilderSelectColumn: 'Selecteer een kolom',
  advancedFilterBuilderSelectOption: 'Selecteer een optie',
  advancedFilterBuilderEnterValue: 'Voer een waarde in...',
  advancedFilterBuilderValidationAlreadyApplied: 'Huidige filter is al toegepast.',
  advancedFilterBuilderValidationIncomplete: 'Niet alle voorwaarden zijn voltooid.',
  advancedFilterBuilderValidationSelectColumn: 'Moet een kolom selecteren.',
  advancedFilterBuilderValidationSelectOption: 'Moet een optie selecteren.',
  advancedFilterBuilderValidationEnterValue: 'Moet een waarde invoeren.',

  // Side Bar
  columns: 'Kolommen',
  filters: 'Filters',
  actions: 'Regel functies',

  // columns tool panel
  pivotMode: 'Pivot-modus',
  groups: 'Rijgroepen',
  rowGroupColumnsEmptyMessage: 'Sleep hier om rijgroepen in te stellen',
  values: 'Waarden',
  valueColumnsEmptyMessage: 'Sleep hier om samen te vatten',
  pivots: 'Kolomlabels',
  pivotColumnsEmptyMessage: 'Sleep hier om kolomlabels in te stellen',

  // Header of the Default Group Column
  group: 'Groep',

  // Row Drag
  rowDragRow: 'rij',
  rowDragRows: 'rijen',

  // Other
  loadingOoo: 'Laden...',
  loadingError: 'FOUT',
  noRowsToShow: 'Geen rijen om weer te geven',
  enabled: 'Ingeschakeld',

  // Menu
  pinColumn: 'Kolom vastzetten',
  pinLeft: 'Links vastzetten',
  pinRight: 'Rechts vastzetten',
  noPin: 'Niet vastzetten',
  valueAggregation: 'Waarde-aggregatie',
  noAggregation: 'Geen',
  autosizeThiscolumn: 'Pas deze kolom automatisch aan',
  autosizeAllColumns: 'Pas alle kolommen automatisch aan',
  groupBy: 'Groepeer op',
  ungroupBy: 'Groepering opheffen',
  ungroupAll: 'Alle groepen opheffen',
  addToValues: '${variable} toevoegen aan waarden',
  removeFromValues: '${variable} verwijderen uit waarden',
  addToLabels: '${variable} toevoegen aan labels',
  removeFromLabels: '${variable} verwijderen uit labels',
  resetColumns: 'Kolommen resetten',
  expandAll: 'Alle rijgroepen uitvouwen',
  collapseAll: 'Alle rijgroepen samenvouwen',
  copy: 'Kopiëren',
  ctrlC: 'Ctrl+C',
  ctrlX: 'Ctrl+X',
  copyWithHeaders: 'Kopiëren met koppen',
  copyWithGroupHeaders: 'Kopiëren met groepskoppen',
  cut: 'Knippen',
  paste: 'Plakken',
  ctrlV: 'Ctrl+V',
  export: 'Exporteren',
  csvExport: 'CSV-export',
  excelExport: 'Excel-export',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Som',
  first: 'Eerste',
  last: 'Laatste',
  min: 'Min',
  max: 'Max',
  none: 'Geen',
  count: 'Aantal',
  avg: 'Gemiddelde',
  filteredRows: 'Gefilterd',
  selectedRows: 'Geselecteerd',
  totalRows: 'Totaal aantal rijen',
  totalAndFilteredRows: 'Rijen',
  more: 'Meer',
  to: 'tot',
  of: 'van',
  page: 'Pagina',
  pageLastRowUnknown: '?',
  nextPage: 'Volgende pagina',
  lastPage: 'Laatste pagina',
  firstPage: 'Eerste pagina',
  previousPage: 'Vorige pagina',

  // Pivoting
  pivotColumnGroupTotals: 'Totaal',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivotdiagram en Pivottomgeving',
  pivotChart: 'Pivotdiagram',
  chartRange: 'Diagrambereik',

  columnChart: 'Kolom',
  groupedColumn: 'Gegroepeerd',
  stackedColumn: 'Gestapeld',
  normalizedColumn: '100% gestapeld',

  barChart: 'Balk',
  groupedBar: 'Gegroepeerd',
  stackedBar: 'Gestapeld',
  normalizedBar: '100% gestapeld',

  pieChart: 'Taart',
  pie: 'Taart',
  doughnut: 'Donut',

  line: 'Lijn',

  xyChart: 'X Y (Verstrooiing)',
  scatter: 'Verstrooiing',
  bubble: 'Bubbel',

  areaChart: 'Gebied',
  area: 'Gebied',
  stackedArea: 'Gestapeld',
  normalizedArea: '100% gestapeld',

  histogramChart: 'Histogram',
  histogramFrequency: "Frequentie",

  combinationChart: 'Combinatie',
  columnLineCombo: 'Kolom en lijn',
  AreaColumnCombo: 'Gebied en kolom',

  // Charts
  pivotChartTitle: 'Pivotdiagram',
  rangeChartTitle: 'Bereikdiagram',
  settings: 'Instellingen',
  data: 'Gegevens',
  format: 'Opmaak',
  categories: 'Categorieën',
  defaultCategory: '(Geen)',
  series: 'Reeksen',
  xyValues: 'X Y-waarden',
  paired: 'Gekoppelde modus',
  axis: 'As',
  navigator: 'Navigator',
  color: 'Kleur',
  thickness: 'Dikte',
  xType: 'X-type',
  automatic: 'Automatisch',
  category: 'Categorie',
  number: 'Nummer',
  time: 'Tijd',
  autoRotate: 'Automatisch draaien',
  xRotation: 'X-rotatie',
  yRotation: 'Y-rotatie',
  ticks: 'Tikken',
  width: 'Breedte',
  height: 'Hoogte',
  length: 'Lengte',
  padding: 'Opvulling',
  spacing: 'Ruimte',
  chart: 'Diagram',
  title: 'Titel',
  titlePlaceholder: 'Diagramtitel - dubbelklik om te bewerken',
  background: 'Achtergrond',
  font: 'Lettertype',
  top: 'Boven',
  right: 'Rechts',
  bottom: 'Onder',
  left: 'Links',
  labels: 'Labels',
  size: 'Grootte',
  minSize: 'Minimale grootte',
  maxSize: 'Maximale grootte',
  legend: 'Legenda',
  position: 'Positie',
  markerSize: 'Markergrootte',
  markerStroke: 'Markerslag',
  markerPadding: 'Markervulling',
  itemSpacing: 'Itemruimte',
  itemPaddingX: 'Itemvulling X',
  itemPaddingY: 'Itemvulling Y',
  layoutHorizontalSpacing: 'Horizontale ruimte',
  layoutVerticalSpacing: 'Verticale ruimte',
  strokeWidth: 'Lijnbreedte',
  lineDash: 'Lijnstreep',
  offset: 'Verschuiving',
  offsets: 'Verschuivingen',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markeringen',
  shadow: 'Schaduw',
  blur: 'Vervaging',
  xOffset: 'X-verschuiving',
  yOffset: 'Y-verschuiving',
  lineWidth: 'Lijnbreedte',
  normal: 'Normaal',
  bold: 'Vet',
  italic: 'Cursief',
  boldItalic: 'Vet cursief',
  predefined: 'Vooraf gedefinieerd',
  fillOpacity: 'Opvuldoorzichtigheid',
  strokeOpacity: 'Lijn-doorzichtigheid',
  histogramBinCount: 'Aantal bakken',
  columnGroup: 'Kolom',
  barGroup: 'Balk',
  pieGroup: 'Taart',
  lineGroup: 'Lijn',
  scatterGroup: 'X Y (Verstrooiing)',
  areaGroup: 'Gebied',
  histogramGroup: 'Histogram',
  combinationGroup: 'Combinatie',
  groupedColumnTooltip: 'Gegroepeerd',
  stackedColumnTooltip: 'Gestapeld',
  normalizedColumnTooltip: '100% gestapeld',
  groupedBarTooltip: 'Gegroepeerd',
  stackedBarTooltip: 'Gestapeld',
  normalizedBarTooltip: '100% gestapeld',
  pieTooltip: 'Taart',
  doughnutTooltip: 'Donut',
  lineTooltip: 'Lijn',
  groupedAreaTooltip: 'Gebied',
  stackedAreaTooltip: 'Gestapeld',
  normalizedAreaTooltip: '100% gestapeld',
  scatterTooltip: 'Verstrooiing',
  bubbleTooltip: 'Bubbel',
  histogramTooltip: 'Histogram',
  columnLineComboTooltip: 'Kolom & Lijn',
  areaColumnComboTooltip: 'Gebied & Kolom',
  customComboTooltip: 'Aangepaste combinatie',
  noDataToChart: 'Geen gegevens beschikbaar om te diagrammeren.',
  pivotChartRequiresPivotMode: 'Pivotdiagram vereist ingeschakelde Pivottomgeving.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Gekoppeld aan raster',
  chartUnlinkToolbarTooltip: 'Ontkoppeld van raster',
  chartDownloadToolbarTooltip: 'Diagram downloaden',
  seriesChartType: 'Grafiektype reeks',
  seriesType: 'Reekstype',
  secondaryAxis: 'Secundaire as',

  // ARIA
  ariaAdvancedFilterBuilderItem: '${variable1}. Niveau ${variable2}. Druk op ENTER om te bewerken.',
  ariaAdvancedFilterBuilderItemValidation: '${variable1}. Niveau ${variable2}. ${variable3} Druk op ENTER om te bewerken.',
  ariaAdvancedFilterBuilderList: 'Lijst van geavanceerde filterbouwer',
  ariaAdvancedFilterBuilderFilterItem: 'Filtervoorwaarde',
  ariaAdvancedFilterBuilderGroupItem: 'Filtergroep',
  ariaAdvancedFilterBuilderColumn: 'Kolom',
  ariaAdvancedFilterBuilderOption: 'Optie',
  ariaAdvancedFilterBuilderValueP: 'Waarde',
  ariaAdvancedFilterBuilderJoinOperator: 'Verbindingsoperator',
  ariaAdvancedFilterInput: 'Geavanceerde filterinvoer',
  ariaChecked: 'aangevinkt',
  ariaColumn: 'Kolom',
  ariaColumnGroup: 'Kolomgroep',
  ariaColumnList: 'Kolommenlijst',
  ariaColumnSelectAll: 'Schakel alle kolommen in/uit',
  ariaDateFilterInput: 'Datumfilterinvoer',
  ariaDefaultListName: 'Lijst',
  ariaFilterColumnsInput: 'Filterkolom invoer',
  ariaFilterFromValue: 'Filter van waarde',
  ariaFilterInput: 'Filterinvoer',
  ariaFilterList: 'Filterlijst',
  ariaFilterToValue: 'Filter tot waarde',
  ariaFilterValue: 'Filterwaarde',
  ariaFilterMenuOpen: 'Open filtermenu',
  ariaFilteringOperator: 'Filteroperator',
  ariaHidden: 'verborgen',
  ariaIndeterminate: 'onbepaald',
  ariaInputEditor: 'Invoerbewerker',
  ariaMenuColumn: 'Druk op CTRL ENTER om kolommenu te openen.',
  ariaRowDeselect: 'Druk op SPATIE om deze rij te deselecteren',
  ariaRowSelectAll: 'Druk op Spatie om alle rijen te selecteren/deselecteren',
  ariaRowToggleSelection: 'Druk op Spatie om rijselectie te wisselen',
  ariaRowSelect: 'Druk op SPATIE om deze rij te selecteren',
  ariaSearch: 'Zoeken',
  ariaSortableColumn: 'Druk op ENTER om te sorteren',
  ariaToggleVisibility: 'Druk op SPATIE om zichtbaarheid te wisselen',
  ariaToggleCellValue: 'Druk op SPATIE om celwaarde te wisselen',
  ariaUnchecked: 'niet aangevinkt',
  ariaVisible: 'zichtbaar',
  ariaSearchFilterValues: 'Zoek filterwaarden',

  // ARIA Labels for Drop Zones

  ariaRowGroupDropZonePanelLabel: 'Rijgroepen',
  ariaValuesDropZonePanelLabel: 'Waarden',
  ariaPivotDropZonePanelLabel: 'Kolomlabels',
  ariaDropZoneColumnComponentDescription: 'Druk op DELETE om te verwijderen',
  ariaDropZoneColumnValueItemDescription: 'Druk op ENTER om het aggregatietype te wijzigen',
  ariaDropZoneColumnGroupItemDescription: 'Druk op ENTER om te sorteren',
  // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
  ariaDropZoneColumnComponentAggFuncSeparator: ' van ',
  ariaDropZoneColumnComponentSortAscending: 'oplopend',
  ariaDropZoneColumnComponentSortDescending: 'aflopend',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: 'Kolommenu',
  ariaLabelCellEditor: 'Celbewerker',
  ariaLabelDialog: 'Dialoogvenster',
  ariaLabelSelectField: 'Selecteer veld',
  ariaLabelRichSelectField: 'Selecteer veld met opmaak',
  ariaLabelTooltip: 'Tooltip',
  ariaLabelContextMenu: 'Contextmenu',
  ariaLabelSubMenu: 'Submenu',
  ariaLabelAggregationFunction: 'Aggregatiefunctie',
  ariaLabelAdvancedFilterAutocomplete: 'Automatisch aanvullen geavanceerd filter',
  ariaLabelAdvancedFilterBuilderAddField: 'Veld toevoegen aan geavanceerde filterbouwer',
  ariaLabelAdvancedFilterBuilderColumnSelectField: 'Selecteer veld in geavanceerde filterbouwer',
  ariaLabelAdvancedFilterBuilderOptionSelectField: 'Selecteer optie in geavanceerde filterbouwer',
  ariaLabelAdvancedFilterBuilderJoinSelectField: 'Selecteer verbindingsoperator in geavanceerde filterbouwer',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.',

  // Data types
  true: 'Waar',
  false: 'Onwaar',
  invalidDate: 'Ongeldige datum',
  invalidNumber: 'Ongeldig nummer',
  january: 'januari',
  february: 'februari',
  march: 'maart',
  april: 'april',
  may: 'mei',
  june: 'juni',
  july: 'juli',
  august: 'augustus',
  september: 'september',
  october: 'oktober',
  november: 'november',
  december: 'december',
};

var index = {
  'en-US': en,
  'fi-FI': fi,
  'sv-SE': sv,
  'nl-NL': nl,
};

export { index as AGGridTranslations };
